import Vue from "vue";
import Vuex from "vuex";
import { state, getters, actions, mutations } from "./mutations";
import * as interview from "./interview";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  actions,
  mutations,
  modules: {
    interview: {
      namespaced: true,
      state: interview.state,
      getters: interview.getters,
      actions: interview.actions,
      mutations: interview.mutations
    }
  }
});
